// components/schema/SchemaToolbar.jsx

import React from "react"

export default function SchemaToolbar({
  schemaName,
  setSchemaName,
  editingId,
  onSaveSchema,
  onSaveAsNew,
  onValidate,
  onDownload,
}) {
  return (
    <div className="flex items-center gap-2 mb-3">
      <input
        value={schemaName}
        onChange={(e) => setSchemaName(e.target.value)}
        placeholder="Schema name…"
        className="h-9 px-3 rounded-md border border-gray-300 bg-white text-gray-900 w-[260px]
                   dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700"
      />
      <button
        onClick={onSaveSchema}
        className="h-9 px-3 rounded-md bg-emerald-600 text-white hover:bg-emerald-700"
      >
        {editingId ? "Save Changes" : "Save Schema"}
      </button>
      {editingId && (
        <button
          onClick={onSaveAsNew}
          className="h-9 px-3 rounded-md border border-gray-300 bg-white hover:bg-gray-50 text-gray-700
                     dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700 dark:hover:bg-gray-700"
        >
          Save as New
        </button>
      )}
      <button
        onClick={onValidate}
        className="px-3 py-1.5 rounded-md bg-blue-600 text-white hover:bg-blue-700"
      >
        Check Syntax
      </button>
      <button
        onClick={onDownload}
        className="px-3 py-1.5 rounded-md border border-gray-300 bg-white hover:bg-gray-50 text-gray-700
                   dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700 dark:hover:bg-gray-700"
      >
        Download
      </button>
    </div>
  )
}
